import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { palette } from '../../../system/styles/styles';
import { css } from '@emotion/react';
import ClipLoader from 'react-spinners/ClipLoader';
import { Modal } from '@material-ui/core';

const MainContainer = styled.main`
  display: grid;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 10000;
`;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  background: none;
`;

const ModalLoad = () => {
  const { load } = useSelector((state) => state);
  return (
    <Modal
      open={!load}
      onClose={() => {}}
      closeOnEsc={false}
      classNames={{
        modal: 'customModalAnalitics',
      }}
      showCloseIcon={false}
      focusTrapped={false}>
      <MainContainer>
        <ClipLoader css={override} size={35} color={palette.blue} />
      </MainContainer>
    </Modal>
  );
};

export default ModalLoad;
